/**------------------------------------------------------
 * Probability
 */
export class StatsProbability {

	/**------------------------------------------------------
	 * ToDo List
	 */
	// factorial(value: number): numberInstancesDistribution;

	// powerset<T>(dataset: T[]): Array<T[]>InstancesDistribution;

	// permutations<T>(dataset: T[]): Array<T[]>InstancesDistribution;
}
